import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=3a5fe2cc&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Ranking.vue?vue&type=style&index=0&id=3a5fe2cc&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3a5fe2cc",
  "326e01a5"
  
)

export default component.exports